import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AccountBuilderComponent} from './components/account-builder/account-builder.component';
import {AccountEditorComponent} from './components/account-editor/account-editor.component';
import {AccountListViewComponent} from './components/account-list-view/account-list-view.component';
import {FormsModule} from '@angular/forms';
import {DropdownModule} from 'primeng/dropdown';
import {DialogModule} from 'primeng/dialog';
import {UserListViewComponent} from './components/user-list-view/user-list-view.component';
import {VirtualScrollModule} from '../virtual-scroll/virtual-scroll.module';
import {TooltipModule} from 'primeng/tooltip';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {RippleModule} from 'primeng/ripple';
import {LayoutLibraryModule} from '../_layout-library/layout-library.module';
import {WidgetLibraryModule} from '../_widget-library/widget-library.module';
import {AppCommonModule} from '../app-common/app-common.module';


@NgModule({
  declarations: [
    AccountBuilderComponent,
    AccountEditorComponent,
    AccountListViewComponent,
    UserListViewComponent,
  ],
    imports: [
        CommonModule,
        FormsModule,
        DropdownModule,
        DialogModule,
        VirtualScrollModule,
        TooltipModule,
        AutoCompleteModule,
        RippleModule,
        LayoutLibraryModule,
        WidgetLibraryModule,
        AppCommonModule,
    ],
  exports: [
    AccountBuilderComponent,
    AccountEditorComponent,
    AccountListViewComponent,
    UserListViewComponent,
  ]
})
export class UserModule {
}
